import React, { useState } from "react";
import API from "../../services/api.ts";
import { toast } from "react-toastify";

const ProjectForm = ({ onClose, onSuccess, project = null }) => {
    const isEditing = !!project;
    const [formData, setFormData] = useState({
        name: project?.name || "",
        description: project?.description || "",
        visibility: project?.visibility || "private",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim()) {
            toast.error("Project name is required.");
            return;
        }

        try {
            setLoading(true);
            if (isEditing) {
                await API.patch(`/projects/${project.id}/`, formData);
                toast.success("Project updated successfully.");
            } else {
                await API.post("/projects/", formData);
                toast.success("Project created successfully.");
            }
            onSuccess();
        } catch (err) {
            console.error("Error saving project:", err);
            toast.error(err.response?.data?.detail || "Failed to save project.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="modal d-block"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {isEditing ? "Edit Project" : "Create New Project"}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={loading}
                        ></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">
                                    Project Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter project name"
                                    required
                                    autoFocus
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Describe your project (optional)"
                                    rows={3}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Visibility</label>
                                <select
                                    className="form-select"
                                    name="visibility"
                                    value={formData.visibility}
                                    onChange={handleChange}
                                >
                                    <option value="private">
                                        Private - Only members can access
                                    </option>
                                    <option value="public">
                                        Public - Anyone can view
                                    </option>
                                </select>
                                <small className="text-muted">
                                    {formData.visibility === "private"
                                        ? "Only you and invited members will be able to access this project."
                                        : "Anyone can view this project, but only members can edit."}
                                </small>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                        ></span>
                                        Saving...
                                    </>
                                ) : isEditing ? (
                                    "Save Changes"
                                ) : (
                                    "Create Project"
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ProjectForm;
